import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface MobileListItemContentProps {
  children: ReactNode;
  className?: string;
}

export function MobileListItemContent({
  children,
  className,
}: MobileListItemContentProps) {
  return <div className={cn("space-y-2", className)}>{children}</div>;
}
